import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "alloys" };
const _hoisted_2 = {
    key: 0,
    class: "my-5 w-full flex justify-center"
};
const _hoisted_3 = {
    key: 0,
    class: "h1 mb-[30px] lg:mb-[40px]"
};
const _hoisted_4 = { class: "offset-header-on-scroll" };
const _hoisted_5 = { class: "mt-5 flex" };
const _hoisted_6 = { class: "footnote text-sm text-gray-500 mt-5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            ($setup.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode($setup["LoadingSpinner"])
                ]))
                : ($setup.error)
                    ? (_openBlock(), _createBlock($setup["LoadingError"], {
                        key: 1,
                        title: $setup.error
                    }, null, 8 /* PROPS */, ["title"]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.alloys, (alloy, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                            (alloy.sectionTitle)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(alloy.sectionTitle), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alloy.tables, (table) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                    (table.caption)
                                        ? (_openBlock(), _createBlock($setup["SmartComponent"], {
                                            key: 0,
                                            data: table.caption
                                        }, null, 8 /* PROPS */, ["data"]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("table", null, [
                                        _createElementVNode("thead", _hoisted_4, [
                                            _createElementVNode("tr", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.head, (head) => {
                                                    return (_openBlock(), _createElementBlock("th", null, _toDisplayString(head), 1 /* TEXT */));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.body.rows, (row) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                                                        return (_openBlock(), _createElementBlock("td", null, [
                                                            _createVNode($setup["SmartComponent"], { data: cell }, null, 8 /* PROPS */, ["data"])
                                                        ]));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]));
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]));
                    }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_5, [
                _createVNode($setup["QueryWithSearchDropdown"], {
                    "filter-key": "date",
                    "filter-options": $setup.dateOptions,
                    "default-value": [$setup.dateOptions[0]]
                }, null, 8 /* PROPS */, ["filter-options", "default-value"])
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString($setup.$t('All operating and price changes, the correction of mistakes, typographical errors, calculating errors, the exchange rate, tariff changes, especially by transport operators, are reserved.')), 1 /* TEXT */)
        ]),
        _createVNode($setup["AlloyDialog"], {
            isOpen: $setup.isOpen,
            query: $setup.alloyQuery,
            onClose: $setup.closeDialog
        }, null, 8 /* PROPS */, ["isOpen", "query"])
    ], 64 /* STABLE_FRAGMENT */));
}
